/* API version of contacts store model */
export const state = () => ({
  host: process.env.apiUrl,
  cities: {
    loaded: true,
    items: [],
  },
  office: {
    loaded: true,
    single: null,
  },
  warehouse: {
    loaded: true,
    single: null,
  },
  prods: {
    loaded: true,
    items: [],
  },
});

export const mutations = {
  setCityList: function (state, { items }) {
    state.cities.loaded = true;
    state.cities.items = items;
  },
  setOffice: function (state, { id, single }) {
    // Office
    state.office.loaded = true;
    state.office.single = {
      id: single.id,
      title: single.title,
      coords: {
        lat: single.office_gps_lat,
        lng: single.office_gps_lon
      },
      email: single.email,
      address: single.office_address,
      phone: single.office_phone,
      time: single.office_time,
      reach: single.office_how_to_get ? single.office_how_to_get : null,
    };

    // Warehouse (if is)
    state.warehouse.loaded = true;

    state.warehouse.single = {
      id: single.id,
      title: single.title,
      coords: {
        lat: single.wh_gps_lat,
        lng: single.wh_gps_lon
      },
      email: single.email_wh,
      address: single.wh_address,
      phone: single.wh_phone,
      time: single.wh_time,
      reach: single.wh_how_to_get ? single.wh_how_to_get : null,
    };

  },


  setProds: function (state, { items }) {
    state.prods.loaded = true;
    state.prods.items = items;
  },
};

export const actions = {

  loadCities({ commit, dispatch, state }) {

   // console.log('load API version of cities');
    return this.$axios.post(`${state.host}/methods/offices/get_list/`).then(
      (response) => {
        //console.log(response.data)
        commit('setCityList', { items: response.data });
        return true;
      },
      (error) => {
        dispatch('showRequestError', error, { root: true });
        return false;
      }
    );
  },
  /* Load office */
  loadOffice({ commit, dispatch, state }, { id }) {
    console.log('load API version of office, id = ', id);
    return this.$axios.get(`${state.host}/methods/offices/get_item/?id=${id}`).then(
      (response) => {
        commit('setOffice', { id: id, single: response.data });
        return true;
      },
      (error) => {
        dispatch('showRequestError', error, { root: true });
        return false;
      }
    );
  },

  /* Load office */
  loadProds({ commit, dispatch, state }, {sid, id }) {
    return this.$axios.get(`${state.host}/methods/prods/get_catalog/?sid=${sid}&rid=${id}`).then(
      (response) => {
        commit('setProds', {items: response.data });
        return true;
      },
      (error) => {
        dispatch('showRequestError', error, { root: true });
        return false;
      }
    );
  },
};



// WEBPACK FOOTER //
// ./store/contacts.js